import { createFileRoute } from '@tanstack/react-router';
import { HomeGate } from '@/features/account/shell/HomeGate';
import JobRejectionReasonEmailPage from '@/features/jobs/job-rejection-reason-email';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/vagas/motivo-reprovacao-email')({
  component: () => (
    <HomeGate>
      <JobRejectionReasonEmailPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
